import React, { useEffect, FC } from 'react';
import { Card, CardContent, Button, Typography, Box } from '@mui/material';
import { SCUIContent } from '../../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import MuseumOutlinedIcon from '@mui/icons-material/MuseumOutlined';
import Helper from '../../../utils/helper';
import jwt_decode from 'jwt-decode';
import SecurityIcon from '@mui/icons-material/Security';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useHistory, useLocation } from 'react-router-dom';
import { PageUrl } from '../../../types/enums';

import './Home.scss';
import AuthService from '../../../services/auth/Auth.services';
import { meymunHome } from '../../../assets/images';
import { RoleRequestGuideModal } from './components/RoleRequestGuideModal';
// import { StickyNotes } from '@/pages/RoleApproval/PendingRoleRequests/StickyNotes';

export const Home: FC<any> = (props: any) => {
    const [userName, setUserName] = React.useState('');
    const [guideOpen, setGuideOpen] = React.useState(false);

    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();

    const getStoreCode = function () {
        return localStorage.getItem('storeCode');
    };

    const authService = new AuthService();
    interface JwtPayload {
        name: string;
    }

    useEffect(() => {
        const hash = props?.history?.location?.hash;
        const el = hash && document.getElementById(hash.substr(1));
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        //testyayin için kapandı açılacak  getCommentList();
    }, [props?.history?.location?.hash]);

    useEffect(() => {
        getUserName();
    }, []);

    useEffect(() => {
        if (location.pathname === PageUrl.requestRoleGuide.url) {
            setGuideOpen(true);
        }
    }, [location.pathname]);

    const getUserName = () => {
        authService.getUserInfo().then((getUserInfo: any) => {
            if (!Helper.isNil(getUserInfo)) {
                const decodedToken: any = jwt_decode<JwtPayload>(getUserInfo.access_token);
                setUserName(decodedToken.preferred_username);
            }
        });
    };

    const handleRoleRequestNavigation = () => {
        history.push(PageUrl.requestRole.url);
    };

    const handleGuideOpen = () => {
        history.push(PageUrl.requestRoleGuide.url);
    };

    const handleGuideClose = () => {
        setGuideOpen(false);
        history.push(PageUrl.home.url);
    };

    const handleGuideRequestRole = () => {
        setGuideOpen(false);
        history.push(PageUrl.requestRole.url);
    };

    return (
        <div className="home">
            <SCUIContent headerName={' '}>
                {/* <StickyNotes storageKey="home_stickyNotes" /> */}
                <Box
                    sx={{
                        width: '550px',
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Card
                        className="testYayin"
                        sx={{
                            width: '100%',
                            padding: '16px',
                            background: 'linear-gradient(to left bottom, #3d8bfd, #07377f)',
                            color: 'white',
                            height: '16rem',
                        }}
                    >
                        <CardContent sx={{ height: '100%', position: 'relative', p: 2, display: 'flex' }}>
                            <Box
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    gap: 3,
                                }}
                            >
                                {!Helper.getStoreCode() ? (
                                    <Box
                                        component="img"
                                        src={meymunHome}
                                        alt=""
                                        sx={{
                                            width: '250px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            flexShrink: 0,
                                        }}
                                    />
                                ) : (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            flexShrink: 0,
                                        }}
                                    >
                                        <MuseumOutlinedIcon sx={{ fontSize: '13rem' }} />
                                    </Box>
                                )}

                                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                                        {t('general.welcome')}
                                    </Typography>
                                    <Typography variant="h6" sx={{ mt: 1, fontWeight: 500 }}>
                                        {userName}
                                    </Typography>
                                </Box>
                            </Box>

                            {getStoreCode() && (
                                <Box
                                    sx={{
                                        marginLeft: 'auto !important',
                                        fontStyle: 'italic',
                                        fontSize: 25,
                                        fontWeight: 700,
                                        height: '100%',
                                        marginTop: '64px',
                                    }}
                                >
                                    {getStoreCode()}
                                </Box>
                            )}
                        </CardContent>
                    </Card>

                    {!Helper.getStoreCode() && (
                        <Box sx={{ mt: 3 }}>
                            <Box sx={{ display: 'flex' }}>
                                <Box sx={{ width: '550px' }}>
                                    <Card
                                        sx={{
                                            background: 'linear-gradient(to right bottom, #f8f9fa, #e9ecef)',
                                            border: '1px solid #dee2e6',
                                            height: '16rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '100%',
                                        }}
                                    >
                                        <CardContent sx={{ padding: '16px !important', width: '100%' }}>
                                            <Box
                                                display="flex"
                                                flexDirection="column"
                                                alignItems="center"
                                                textAlign="center"
                                            >
                                                <Typography
                                                    variant="h5"
                                                    component="h2"
                                                    sx={{ color: '#495057', fontWeight: 'bold', mb: 2 }}
                                                >
                                                    {t('home.roleRequest.title')}
                                                </Typography>
                                                <Typography variant="body1" sx={{ color: '#6c757d', mb: 3 }}>
                                                    {t('home.roleRequest.description')}
                                                </Typography>
                                                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="large"
                                                        onClick={handleRoleRequestNavigation}
                                                        startIcon={<SecurityIcon />}
                                                        sx={{
                                                            background: 'linear-gradient(to right, #007bff, #0056b3)',
                                                            padding: '8px 16px !important',
                                                            fontSize: '1.1rem',
                                                            fontWeight: 'bold',
                                                            color: 'white',
                                                        }}
                                                    >
                                                        {t('home.roleRequest.buttonText')}
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="large"
                                                        onClick={handleGuideOpen}
                                                        startIcon={<HelpOutlineIcon />}
                                                        className="guide-button-pulse"
                                                        sx={{
                                                            background: 'linear-gradient(to right, #007bff, #0056b3)',
                                                            padding: '8px 16px !important',
                                                            fontSize: '1.1rem',
                                                            fontWeight: 'bold',
                                                            color: 'white',
                                                        }}
                                                    >
                                                        {t('home.roleRequest.guideButtonText')}
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    <RoleRequestGuideModal
                        open={guideOpen}
                        onClose={handleGuideClose}
                        onRequestRole={handleGuideRequestRole}
                    />
                </Box>
            </SCUIContent>
        </div>
    );
};
